import { AfterViewInit, Component, OnInit } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "../../service/user.service";
import { User } from "../../../generated/graphql";
import { QueryRef } from "apollo-angular";
import { Employee, GetEmployeeByReQuery } from "src/app/model/employee";
import { GetEmployeeByReGQL } from "graphql/employee/employee.definition";
import { GetWalletByEmployeeIdGQL } from "graphql/wallet/wallet.definition";
import { WalletService } from "../../service/wallet.service";

declare var $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  opened = false;
  user: User = {} as User;
  employee: Employee;
  walletValue: number = 0;
  getEmployeeByReQuery: QueryRef<GetEmployeeByReQuery>;

  constructor(
    public router: Router,
    public translate: TranslateService,
    public userService: UserService,
    private employeeGQL: GetEmployeeByReGQL,
    private walletService: GetWalletByEmployeeIdGQL,
    private walletServicesAfter: WalletService,
  ) {
    super(router, translate);
  }

  menu() {
    this.opened = !this.opened;
  }

  ngOnInit(): void {
    const re = localStorage.getItem("re");
    re ? this.getEmployee(re) : this.getUser();
  }

  ngAfterViewInit() {
    window.onscroll = () => {
      const hero = document.querySelector<HTMLElement>(".hero-bar");
      const header = document.querySelector<HTMLElement>(".header");

      if (hero != null) {
        window.scrollY >= hero.offsetHeight - 105
          ? header.classList.add("dark")
          : header.classList.remove("dark");
      }
    };
  }

  onNavigateRouter(s: string) {
    this.router.navigate([s]);
  }

  getUser() {
    this.userService.user.subscribe({
      next: (data) => {
        this.user = data as User;

        if (this.user?.id) {
          console.log("Uduário não possui um employee");
          const employeeId = this.user.employee?.id;
          if (employeeId) {
            this.getWallet(employeeId);
            localStorage.setItem("employeeId", employeeId);
          }
        }
      },
      error: (err) => {
        super.onError(err);
      },
    });
  }

  getEmployee(re: string) {
    this.getEmployeeByReQuery = this.employeeGQL.watch({ re });
    this.getEmployeeByReQuery.valueChanges.subscribe({
      next: ({ data }) => {
        this.employee = {
          id: data.getEmployeeRe.id,
          name: data.getEmployeeRe.name,
          re: data.getEmployeeRe.re,
          rhArea: "",
          dateOfBirth: Date.now(),
          email: "",
          status: "",
        };
        // A sessao por RE tambem precisa do employeeId: a mutation de troca da
        // loja exige esse campo e so o ramo SSO gravava, deixando o checkout
        // por RE sem saida.
        localStorage.setItem('employeeId', this.employee.id);
        this.getWallet(this.employee.id);
      },
      error: () => {
        this.showMessage(
          this.translate.instant("attention"),
          this.translate.instant("ReError"),
          "warning",
        );
      },
    });
  }

  getWallet(employeeId: string) {
    this.walletService.watch({ employeeId }).valueChanges.subscribe({
      next: ({ data }) => {
        const wallet = data?.getWalletByEmployeeId;
        if (wallet) {
          this.walletValue = wallet.value;
          this.walletServicesAfter.updateWalletValue(wallet.value);
        }
      },
      error: (error) => {
        console.error("Erro ao buscar a carteira:", error);
      },
    });
  }

  actionLogout() {
    // Logout centralizado em BaseComponent: ramo SSO (Azure AD) x ramo RE (só local). Ver base.component.ts.
    this.logout();
  }
}
